import React, { useContext } from 'react';
import { autoCreateQuery as personAutoCreate, client as personClient } from '../../../common/components/person/person';
import { FormContext } from '../../../common/form/FormContext';
import { useMutationWithContext } from '../../../common/hooks/useMutationWithContext';
import I18n, { useI18n } from '../../../common/i18n/I18n';
import { autoCreateQuery as orgAutoCreateQuery, client as orgClient } from '../../../organization/organization';
import { getOption, quickAddOrganization } from '../../../organization/QuickAddOrganization';
import { quickAddPerson } from '../../../person/helpers/QuickAddPerson';
import { RESOURCE_STATE, RESOURCE_TYPE } from '../resourceConstants';
import { Resource_Field_Names } from '../../resourceUtils';
import OrganizationOptionRenderer from '../../../organization/OrganizationOptionRenderer';
import FormItem from '../../../common/form/FormItem';
import FormWidget from '../../../common/form/FormWidget';
import { FormContainer } from '../../../common/form/FormContainer';

export default () => {
    const { state } = useContext(FormContext);
    const [saveOrganization] = useMutationWithContext(orgAutoCreateQuery, orgClient);
    const [savePerson] = useMutationWithContext(personAutoCreate, personClient);

    const isCastOrCrew = [RESOURCE_TYPE.crew, RESOURCE_TYPE.cast].includes(state.type);
    const typePrefix = isCastOrCrew ? RESOURCE_TYPE.hiring : RESOURCE_TYPE.procurement;

    return (
        <FormContainer titleI18nToken={'common.hiring.info'}>
            <FormItem half>
                <FormWidget
                    name={Resource_Field_Names['acquisitionLead']}
                    label={<I18n token={`form.resource.${typePrefix}.lead`} />}
                    component="ReferenceAutocomplete"
                    entity="Person"
                    preload={false}
                    addOption
                    saveMutation={savePerson}
                    onCreateHandle={quickAddPerson}
                />
            </FormItem>
            <FormItem half>
                <FormWidget
                    name={Resource_Field_Names['hiringTeamMembers']}
                    label={<I18n token={`form.resource.${typePrefix}.team`} />}
                    component="ReferenceAutocomplete"
                    entity="Person"
                    preload={false}
                    multiple
                    addOption
                    saveMutation={savePerson}
                    onCreateHandle={quickAddPerson}
                />
            </FormItem>
            <FormItem half hidden={!isCastOrCrew}>
                <FormWidget
                    name={Resource_Field_Names['hiredPerson']}
                    label={<I18n token="form.resource.hired.person" />}
                    component="ReferenceAutocomplete"
                    entity="Person"
                    preload={false}
                    addOption
                    saveMutation={savePerson}
                    onCreateHandle={quickAddPerson}
                />
            </FormItem>
            <FormItem half hidden={isCastOrCrew}>
                <FormWidget
                    name={Resource_Field_Names['hiredOrganization']}
                    label={<I18n token="form.resource.hiring.org" />}
                    component="ReferenceAutocomplete"
                    entity="Organization"
                    OptionRenderer={OrganizationOptionRenderer}
                    onCreateHandle={quickAddOrganization}
                    getOption={getOption}
                    saveMutation={saveOrganization}
                    addOption
                    filter={{
                        expressions: [{ field: 'inactive', value: { values: ['false'] } }]
                    }}
                    notOnlyRef
                    preload={false}
                />
            </FormItem>
            <FormItem half>
                <FormWidget
                    name={Resource_Field_Names['state']}
                    label={useI18n('form.resource.hired.state')}
                    component={'Autocomplete'}
                    options={RESOURCE_STATE}
                />
            </FormItem>
        </FormContainer>
    );
};
